var _defs, _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMaporules(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 13 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{isolation:isolate;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 13,
    height: 12
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Admin"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "iconrules"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Shape"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M12.8,1.45A1.44,1.44,0,0,0,11.38,0H3.22A1.36,1.36,0,0,0,1.87,1.37l-.06,7.5H0v1.28A1.82,1.82,0,0,0,1.73,12h7a1.81,1.81,0,0,0,1.8-1.83V3.56H12.8Zm-11,10A1.27,1.27,0,0,1,.54,10.17V9.42H6.9v.73a1.88,1.88,0,0,0,.51,1.28ZM10,1.45v8.72a1.27,1.27,0,1,1-2.53,0V8.87H2.35l.06-7.5A.82.82,0,0,1,3.22.55h7A1.46,1.46,0,0,0,10,1.45ZM12.26,3H10.51V1.45a.91.91,0,0,1,.41-.87.85.85,0,0,1,.94,0,.92.92,0,0,1,.4.87Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 3.55,
    y: 5.61,
    width: 5.07,
    height: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle-2",
    "data-name": "Rectangle"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 3.55,
    y: 7.27,
    width: 5.07,
    height: 1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "MAPO",
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M4,3.87l.35.87.06.15h0l.06-.15.35-.87h.37v1.5H4.91V4.44h0l-.06.15-.3.78H4.32L4,4.59,4,4.44H4v.93h-.3V3.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M6.36,5.07H5.81l-.08.3H5.37l.52-1.5h.4l.53,1.5H6.44Zm-.31-.79-.15.51h.38l-.15-.51,0-.16h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M8.1,4.38a.65.65,0,0,1,0,.21.39.39,0,0,1-.1.16.51.51,0,0,1-.18.09.77.77,0,0,1-.27,0h-.2v.49H7V3.87h.54A.67.67,0,0,1,8,4,.51.51,0,0,1,8.1,4.38Zm-.35,0a.27.27,0,0,0,0-.11.08.08,0,0,0,0-.07l-.07,0H7.31v.46h.31l.07,0s0,0,0-.07A.36.36,0,0,0,7.75,4.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M9.57,4.62a1.78,1.78,0,0,1,0,.35.9.9,0,0,1-.12.24.48.48,0,0,1-.2.14,1,1,0,0,1-.3,0A.62.62,0,0,1,8.4,5.2a.91.91,0,0,1-.16-.58,1.69,1.69,0,0,1,0-.35A.67.67,0,0,1,8.4,4a.41.41,0,0,1,.2-.14,1,1,0,0,1,.31-.05.94.94,0,0,1,.3.05.41.41,0,0,1,.2.14.67.67,0,0,1,.12.24A1.69,1.69,0,0,1,9.57,4.62Zm-.36,0a1.63,1.63,0,0,0,0-.24.38.38,0,0,0,0-.14.25.25,0,0,0-.1-.08l-.14,0-.15,0a.18.18,0,0,0-.09.08.26.26,0,0,0-.06.14,1.63,1.63,0,0,0,0,.24,1.55,1.55,0,0,0,0,.23A.34.34,0,0,0,8.67,5a.16.16,0,0,0,.09.07l.15,0,.14,0A.23.23,0,0,0,9.15,5a.53.53,0,0,0,0-.15A1.55,1.55,0,0,0,9.21,4.62Z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaporules);
export default __webpack_public_path__ + "static/media/maporules.107c807318c5703e650528e6dff88c0e.svg";
export { ForwardRef as ReactComponent };